import { render, staticRenderFns } from "./GenerateComp.vue?vue&type=template&id=5e5b53b1"
import script from "./GenerateComp.vue?vue&type=script&lang=js"
export * from "./GenerateComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports